import React from "react";
import { Input, Progress } from "antd";
import {
  ArrowLeftOutlined,
  ScanOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import "./MobileHeader.css";

interface MobileHeaderProps {
  containerReference: string;
  completedBookings: number;
  totalBookings: number;
  progressPercent: number;
  searchQuery: string;
  onSearchChange: (value: string) => void;
  autoScanEnabled: boolean;
  isUnloadingInProgress: boolean;
  onBack: () => void;
  onShowHelp: () => void;
  onShowOverview: () => void;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({
  containerReference,
  completedBookings,
  totalBookings,
  progressPercent,
  searchQuery,
  onSearchChange,
  autoScanEnabled,
  isUnloadingInProgress,
  onBack,
  onShowHelp,
  onShowOverview,
}) => {
  return (
    <div className="mobile-header">
      {/* Top bar with back button and container info */}
      <div className="mobile-header-top">
        <button className="mobile-back-btn" onClick={onBack}>
          <ArrowLeftOutlined />
        </button>
        <div className="mobile-header-title">
          <div className="container-ref">
            <span className="container-name">📦 {containerReference}</span>
            <button className="stats-badge" onClick={onShowOverview}>
              {completedBookings}/{totalBookings}
            </button>
          </div>
        </div>
        <div className="mobile-header-actions">
          <button className="mobile-icon-btn" onClick={onShowHelp}>
            <QuestionCircleOutlined />
          </button>
        </div>
      </div>

      {/* Progress bar */}
      {isUnloadingInProgress && (
        <div className="mobile-progress-bar">
          <Progress
            percent={Math.round(progressPercent)}
            status={progressPercent === 100 ? "success" : "active"}
            size="small"
            showInfo={false}
            strokeColor={{
              "0%": "#1890ff",
              "100%": "#52c41a",
            }}
          />
        </div>
      )}

      {/* Search bar */}
      <div className="mobile-search-bar">
        <Input
          placeholder="🔍 Scan EAN or search booking ID..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          size="large"
          allowClear
          prefix={
            <ScanOutlined
              style={{ color: autoScanEnabled ? "#52c41a" : "#8c8c8c" }}
            />
          }
          className={autoScanEnabled ? "scanning" : ""}
        />
      </div>

      {/* Scanner mode banner */}
      {isUnloadingInProgress && autoScanEnabled && (
        <div className="mobile-scan-banner">
          <ScanOutlined className="scan-icon" />
          <span className="scan-text">
            🟢 Zebra Scanner Active - Scan to auto-count
          </span>
        </div>
      )}
    </div>
  );
};
